module.exports = __webpack_public_path__ + "img/memo_1793266348261_81600.a2d73805.jpg";